<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
  export default {
    name: 'App',
    methods:{
      handleFontSize() {
        // 设置网页字体为默认大小
        WeixinJSBridge.invoke('setFontSizeCallback', {
          fontSize: 0
        })
        // 重写设置网页字体大小的事件
        WeixinJSBridge.on('menu:setfont', function() {
          WeixinJSBridge.invoke('setFontSizeCallback', {
            fontSize: 0
          })
        })
      }
    },
    mounted(){
      let that = this;
      //安卓端
       if (typeof WeixinJSBridge == 'object' && typeof WeixinJSBridge.invoke == 'function') {
        //判断程序运行环境是否是微信浏览器(微信内置的浏览器)
        this.handleFontSize()
      } else {
        if (document.addEventListener) {
          document.addEventListener('WeixinJSBridgeReady', function(){
            that.handleFontSize();
          }, false)
        } else if (document.attachEvent) {
          document.attachEvent('WeixinJSBridgeReady', function(){
            that.handleFontSize();
          })
          document.attachEvent('onWeixinJSBridgeReady', function(){
            that.handleFontSize();
          })
        }
      }
    },
  }
</script>

<style>
  #app {
    height:inherit;
    font-family:"微软雅黑","Helvetica","宋体";
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    background:#f5f8ff;
  }
.el-menu{
  border-right:none;
}
</style>



// WEBPACK FOOTER //
// src/App.vue